import { render, staticRenderFns } from "./BaseSimpleCard.vue?vue&type=template&id=f895bd90"
import script from "./BaseSimpleCard.vue?vue&type=script&lang=js"
export * from "./BaseSimpleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports